import React, { Fragment, useContext } from "react";
import { FaFilePdf } from "react-icons/fa6";
import { RiSpeakFill, RiRobot2Fill, RiGraduationCapFill } from "react-icons/ri";
import { HiSparkles } from "react-icons/hi2";
import { MdQuiz } from "react-icons/md";
import "../../styles/common.css";
import { WebsiteContext } from "../../context/AppContext";
import 'animate.css'
import ScrollAnimation from 'react-animate-on-scroll';

const Capsule = ({ title, image }) => {
    const {color,isMobileView} = useContext(WebsiteContext);
    
  const imageType = (image) => {
    switch (image) {
      case "spoken_english":
        return <RiSpeakFill style={{height:20, width:20,color:color}}/>;
      case "pdf":
        return <FaFilePdf style={{height:20, width:20,color:color}}/>;
      case "ai_insights":
        return <HiSparkles style={{height:20, width:20,color:color}}/>;
      case "quiz":
        return <MdQuiz style={{height:20, width:20,color:color}}/>;
      case "ai_practice":
        return <RiRobot2Fill style={{height:20, width:20,color:color}}/>;
      case "learning_path":
        return <RiGraduationCapFill style={{height:20, width:20,color:color}}/>;
      default:
        break;
    }
  };
  const handleScroll = () => {
    const idMap = {
      spoken_english: "conversational-english",
      pdf: "comprehensive-mastery",
      ai_insights: "ai-insights",
      quiz: "interactive-quizzes",
      ai_practice: "ai-practice",
      learning_path: "learning-path",
    };
    const targetId = idMap[image];
    if (targetId) {
      const el = document.getElementById(targetId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <Fragment>
    {
      isMobileView ?
      <div className="capsule_container_mobile" onClick={handleScroll} style={{ cursor: "pointer" }}>
      <div className="capsule_image" >{imageType(image)}</div>
      <h2 className="capsule_title" style={{color:color}}>{title}</h2>
    </div>
    :
    <div onClick={handleScroll} style={{ cursor: "pointer" }}>
      <ScrollAnimation animateIn="fadeIn" duration={3} className="capsule_container">
        <div className="capsule_image">{imageType(image)}</div>
        <h2 className="capsule_title" style={{color:color}}>{title}</h2>
      </ScrollAnimation>
    </div>
    }
    </Fragment>
  );
};

export default Capsule;
